const removeTrailingSlash = (path?: string): string => {
    if (!path || typeof path !== 'string') {
        return '';
    }

    return path.replace(/\/$/, '');
};

export default removeTrailingSlash;const removeTrailingSlash = (path?: string): string => {
    if (!path || typeof path !== 'string') {
        return '';
    }

    return path.replace(/\/$/, '');
};

export default removeTrailingSlash;